module.exports = __webpack_public_path__ + "img/playlist_blender_2.aad750ee.png";